module.exports = __webpack_public_path__ + "img/12_40.00848af0.png";